import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";

import routes from "routes.js";

function Auth() {
  const location = useLocation();
  const mainContentRef = React.useRef(null);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
    
    // Only add bg-default class if not on login page
    if (location.pathname !== "/auth/login") {
      document.body.classList.add("bg-default");
    }
    
    return function cleanup() {
      document.body.classList.remove("bg-default");
    };
  });

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  // Check if current page is login
  const isLoginPage = location.pathname === "/auth/login";

  return (
    <>
      <div className="main-content" ref={mainContentRef}>
        {!isLoginPage && <AuthNavbar />}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </div>
      {!isLoginPage && <AuthFooter />}
    </>
  );
}

export default Auth;
